export const PROGRESS_BAR_TEST_ID_SUFFIX = 'progress-bar';
export const SLIDE_MORPH_TEST_ID_SUFFIX = 'slide-morph';
export const STATIC_PROGRESS_VALUE = 50;
